import { render, staticRenderFns } from "./ManifestoSection.vue?vue&type=template&id=5ccda963&scoped=true"
import script from "./ManifestoSection.vue?vue&type=script&lang=js"
export * from "./ManifestoSection.vue?vue&type=script&lang=js"
import style0 from "./ManifestoSection.vue?vue&type=style&index=0&id=5ccda963&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccda963",
  null
  
)

export default component.exports